/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { ReactComponent as ReverLogo } from "../../assets/rever_logo.svg";
import { Button } from "@nextui-org/button";
import AppUserProfile from "../../assets/js/AppUserProfile";
import { Menu } from "lucide-react";
import { ReactComponent as Warning } from "../../assets/icons/warning.svg";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
} from "@nextui-org/modal";
import { annoucements } from "../../constants/annoucement";
import { EntryPoints } from "../../constants/entryPoint";

export const AnnoucementContainer = ({ annoucement }) => {
  const [isAnnouncementOpen, setIsAnnouncementOpen] = useState(false);

  const handleAnnouncementClick = () => {
    setIsAnnouncementOpen(true);
  };

  const handleAnnouncementClose = () => {
    setIsAnnouncementOpen(false);
  };

  return (
    <>
      <div className="bg-black rounded-2xl w-full">
        <div
          className="w-full border-1 border-[#FF0000] bg-[#FF0000]/45 flex rounded-2xl items-center gap-x-7 sm:gap-x-4 px-3 sm:px-4 py-2 sm:py-3 cursor-pointer hover:bg-[#FF0000]/60 transition-colors"
          onClick={handleAnnouncementClick}
        >
          <Warning className="text-warning h-5 w-5 sm:h-7 sm:w-7 flex-shrink-0" />
          <div className="flex flex-col text-white font-semibold text-xs sm:text-sm flex-1 gap-y-2">
            <p className="line-clamp-1">ประกาศแจ้งเพื่อทราบ</p>
            <ul className="list-disc px-5">
              {annoucement.displayTexts?.map((text, index) => {
                return (
                  <li key={index} className="text-base">
                    {text}
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
      <AnnouncementDialog
        isOpen={isAnnouncementOpen}
        onClose={handleAnnouncementClose}
        detailsTexts={annoucement?.detailsTexts}
      />
    </>
  );
};

export const AnnouncementDialog = ({ isOpen, onClose, detailsTexts }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="2xl"
      scrollBehavior="inside"
      hideCloseButton={false}
      placement="center"
      classNames={{
        base: "bg-white",
        wrapper:
          "items-center justify-center p-4 sm:p-6 sm:items-center items-start pt-28",
        backdrop: "bg-black/50",
        header: "border-b border-gray-200",
        body: "py-6",
        footer: "border-t border-gray-200",
        closeButton: "top-4 right-4",
      }}
    >
      <ModalContent>
        <ModalHeader className="flex items-center gap-3">
          <Warning className="text-red-500 h-6 w-6" />
          <span className="text-lg font-semibold text-gray-900">
            ประกาศแจ้งเพื่อทราบ
          </span>
        </ModalHeader>
        <ModalBody>
          <div className="text-gray-700 leading-relaxed space-y-4">
            <ul className="list-disc px-5">
              {detailsTexts?.map((text, index) => (
                <li key={index} className="text-base">
                  {text}
                </li>
              ))}
            </ul>
          </div>
        </ModalBody>
        <ModalFooter className="justify-end">
          <Button
            color="primary"
            onPress={onClose}
            className="bg-blue-600 text-white"
          >
            รับทราบ
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

function Navbar({ toggleSidebar }) {
  const userProfile = AppUserProfile.getData();
  const userRole = userProfile?.whoami;

  const redirectToParent = () => {
    const entryPoint = annoucements.terminateStandAlone[userRole].link;
    window.location.href = entryPoint;
  };

  return (
    <>
      <div className="bg-black w-full h-20 flex items-center px-4 sm:px-8 relative">
        <div className="flex gap-x-2 sm:gap-x-4 items-center flex-shrink-0 z-10">
          <Menu
            className="text-white cursor-pointer w-6 h-6 sm:w-7 sm:h-7"
            onClick={(e) => {
              e.preventDefault();
              toggleSidebar();
            }}
          />
          <p className="text-white font-medium hidden md:block">
            Marketing Claim Activity
          </p>
        </div>

        <div className="ml-2 md:ml-0 md:absolute md:left-1/2 md:transform md:-translate-x-1/2">
          <ReverLogo
            className="w-[60px] md:w-[90px]"
            onClick={() => {
              window.location.href = "/";
            }}
          />
        </div>

        <div className="flex gap-x-2 sm:gap-x-5 items-center flex-shrink-0 ml-auto">
          <p className="text-white text-xs sm:text-sm truncate max-w-24 sm:max-w-none">
            {userProfile.name || ""}
          </p>
          {userRole && (
            <Button
              className="bg-white text-xs sm:text-sm px-2 sm:px-4 py-1 sm:py-2"
              onPress={redirectToParent}
            >
              กลับไป {EntryPoints[userRole]?.parent}
            </Button>
          )}
        </div>
      </div>
    </>
  );
}

export default Navbar;
